import { legalTranslations } from './legal/en';
import { privacyTranslations } from './privacy/en';
import { termsTranslations } from './terms/en';

export const enTranslations = {
  billing: {
    processingTitle: "Finalizing your subscription…",
    processingMessage: "We're confirming your payment, you'll be redirected shortly.",
    confirmed: "Payment confirmed!",
    paymentSuccessful: "Payment successful!",
    signInToAccess: "Sign in to access your Pro account.",
  },
  cookies: {
    bannerTitle: "We respect your privacy",
    bannerDescription:
      "We use cookies to improve your experience and measure how Leadsme is used. Marketing cookies are only enabled with your consent.",
    acceptAll: "Accept all",
    rejectAll: "Reject all",
    preferences: "Preferences",
    privacyLink: "Privacy Policy",
    learnMoreIn: "Learn more in our",
    manageCookies: "Manage cookies",
    preferencesTitle: "Cookie preferences",
    preferencesDescription:
      "Choose which cookies you accept. You can update your choices at any time.",
    categoryNecessary: "Strictly necessary",
    categoryNecessaryDescription:
      "Sign-in, language and core service functionality.",
    categoryMarketing: "Marketing",
    categoryMarketingDescription:
      "Advertising performance measurement. Only set with your consent.",
    alwaysActive: "Always active",
    savePreferences: "Save preferences",
    learnMore: "Learn more:",
  },
  nav: {
    dashboard: "Dashboard",
    upgradeToPro: "Upgrade to Pro",
    tryPro: "Try Pro",
    calendar: "Calendar",
    leads: "Leads",
    projects: "Projects",
    messages: "Messages",
    finances: "Finances",
    settings: "Settings",
    writeToTeam: "Write to the team",
  },
  common: {
    create: "Create",
    new: "New",
    update: "Update",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    undo: "Undo",
    undoing: "Undoing...",
    save: "Save",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filters: "Filters",
    export: "Export",
    import: "Import",
    loading: "Loading...",
    error: "Error",
    logout: "Logout",
    today: "Today",
    validate: "Validate",
    abandon: "Abandon",
    actions: "Actions",
    previous: "Previous",
    next: "Next",
    retry: "Retry",
    allStatus: "All statuses",
    allPeriods: "All periods",
    period: "Period",
    thisMonth: "This month",
    lastMonth: "Last month",
    thisYear: "This year",
    total: "Total",
    clearFilters: "Clear filters",
    tryAdjustingFilters: "Try adjusting or clearing your filters.",
    addFilter: "Add filter",
    filterApply: "Apply",
    filterCancel: "Cancel",
    filter: "Filter",
    filterCondition: "Condition",
    filterValue: "Value",
    filterSelectColumn: "Select column",
    filterOperatorIs: "is",
    filterOperatorIsNot: "is not",
    filterOperatorContains: "contains",
    filterOperatorNotContains: "does not contain",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterOperatorGreaterThan: "is greater than",
    filterOperatorLessThan: "is less than",
    filterOperatorBefore: "is before",
    filterOperatorAfter: "is after",
    filterOperatorHasAnyValue: "has any value",
    moreActions: "More actions",
    selectStatus: "Select Status",
    changeStatus: "Change status",
    confirmBulkStatusChange: "Change status for {{count}} item(s) to \"{{status}}\"?",
    changeContactType: "Change contact type",
    confirmBulkContactTypeChange:
      "Change contact type for {{count}} lead(s) to \"{{type}}\"? Contact values will not be changed.",
    bulkSelectionStale:
      "Some selected items are no longer available. Refresh the page if needed.",
    reload: "Reload",
    backToHome: "Back to home",
    loadingTakingLongTitle: "This is taking longer than expected",
    loadingTakingLongMessage: "You can reload the page or go back to the home page.",
    collapse: "Collapse",
    expand: "Expand",
    close: "Close",
    on: "On",
    off: "Off",
    notAuthenticated: "You must be authenticated to perform this action",
    notes: "Notes",
    saveFailedRollback: "Could not save (network or server issue). Data has been reloaded.",
    exportSuccess: "{{count}} item(s) exported successfully",
    selectedOfTotal: "{{selected}} of {{total}} selected",
    selectedCountOnly: "{{count}} selected",
  },
  followups: {
    count: "Follow-up count",
    maxDisplayed: "Maximum {{max}} displayed",
    title: "Follow-ups",
    all: "All",
    overdue: "Overdue",
    today: "Today",
    relaunch: "Follow up",
    statusTodo: "To do",
    statusLate: "Late",
    statusVeryLate: "Very late",
    seeOthers: "See {{count}} more",
    emptyTab: "Nothing in this tab for now.",
    showMore: "Show more",
    showLess: "Show less",
    moreCount: "more",
    noFollowUps: "No follow-ups in progress",
    noFollowUpsDescription: "Well done! You're all caught up. All your follow-ups are completed.",
  },
  dashboard: {
    title: "Dashboard",
    greetingHello: "Hello 👋",
    greetingHelloName: "Hello, {{name}} 👋",
    subtitle: "Your activity at a glance.",
    commercialPipeline: "Commercial Pipeline",
    conversionRate: "Conversion Rate",
    conversionRateTooltip: "Percentage of leads in production or completed. Calculation: (In production + Completed / Total leads) × 100",
    pipelineStageTooltip: "View all \"{{status}}\" leads",
    pipelineStageTooltipClear: "Clear \"{{status}}\" filter",
    noFollowUpScheduled: "No follow-up scheduled today",
    recentProjects: "Recent Projects",
    noRecentProjects: "No recent projects",
    urgentActions: "Urgent Actions",
    followUpScheduled: "Follow-up scheduled",
    paymentsDue: "Payments Due",
    dueDate: "Due Date",
    pending: "Pending",
    topLeads: "Top Leads",
    topProjects: "Top Projects",
    noDataYet: "No data yet",
    unknownLead: "Unknown lead",
    congratulations: "Congratulations!",
    bestLeadMessage: "<strong>{{name}}</strong> represents {{percentage}}% of your revenue {{period}}.",
    bestProjectMessage: "<strong>{{name}}</strong> represents {{percentage}}% of your revenue {{period}}.",
    thisMonth: "this month",
    thisYear: "this year",
    total: "total",
    rightsWatchTitle: "Image rights to review",
    rightsWatchSubtitle: "Oldest unchecked rights end dates first.",
    rightsUntil: "Until {{date}}",
    rightsExpiredOn: "Expired on {{date}}",
    rightsExpired: "Expired",
    rightsInProgress: "In progress",
    rightsMarkChecked: "Honored",
    rightsMarkedChecked: "Image rights marked as honored: {{name}}",
    rightsMarkCheckedError: "Could not mark image rights as honored",
    noRightsToWatch: "No image rights to review",
    firstLeadHint: "Add your first brand to get started.",
    firstLeadCta: "Create my first lead",
    firstProjectHint: "Turn a collab into a project to track it.",
    firstProjectCta: "Create my first project",
  },
  demoTour: {
    badge: "Demo",
    back: "Back",
    next: "Next",
    createWorkspace: "Create my workspace",
    createdToast: "Workspace ready",
    readonlyToast: "This is a read-only demo. You’ll be able to edit everything in your own workspace.",
    actionError: "Couldn’t leave demo mode",
    welcomeTitle: "Welcome to Leadsme",
    welcomeSubtitle: "A quick 1-minute tour?",
    welcomeBody: "Your workspace is empty. We’ve prepared a short demo with sample data.",
    welcomeYes: "Yes, start the demo",
    welcomeNo: "No, create my empty workspace",
    deferredTitle: "The demo is on desktop",
    deferredBody: "You can already use your workspace here. The guided tour will wait for you on a computer.",
    deferredDismiss: "Got it",
    stepDashboard: "Dashboard",
    stepDashboardBody: "Everything that deserves your attention, in one place. Start the day knowing exactly what to do.",
    stepLeads: "Leads",
    stepLeadsBody: "Track every brand, from first contact to collaboration. All the useful details stay one click away.",
    stepProjects: "Projects",
    stepProjectsBody: "Keep the brief, deliverables, deadlines, and rights for each collab in one place. You always know where the project stands.",
    stepMessages: "Messages",
    stepMessagesBody: "Prep outreach and follow-ups faster. Pick a template, personalize it, and send it to the brand.",
    stepFinances: "Finances",
    stepFinancesBody: "Keep an eye on payments received, upcoming, or overdue. A clear view of your cash flow, without a spreadsheet.",
    stepCalendar: "Calendar",
    stepCalendarBody: "Shoots, meetings, and follow-ups in one schedule. See your week without missing anything.",
  },
  leads: {
    title: "Leads",
    singular: "Lead",
    createNew: "New Lead",
    createNamed: "Create “{{name}}”",
    searchLead: "Search for a lead...",
    created: "{{name}} created",
    createError: "Could not create the lead",
    name: "Name",
    contactType: "Contact Type",
    contactValue: "Contact",
    sector: "Sector",
    status: "Status",
    source: "Source",
    notes: "Notes",
    createdAt: "Created at",
    lastAction: "Last Action",
    nextAction: "Next Action",
    nextFollowUp: "Next Follow-up",
    noLeadsToExport: "No leads to export. Check your filters.",
    deleted: "{{name}} deleted",
    confirmDeleteWithProjectsTitle: "Delete this lead?",
    confirmDeleteWithProjects:
      "This lead has {{count}} linked project(s). Those projects, their payments, and their files will be permanently deleted.",
    confirmBulkDelete: "Delete {{count}} leads?",
    confirmBulkDeleteWithProjects:
      "Delete {{count}} leads? This will also permanently delete {{projectCount}} linked project(s), their payments, and their files.",
    bulkContactTypeUpdated: "Contact type updated for {{count}} lead(s)",
    notesPlaceholder: "Additional information, exchange history...",
    noLeads: "No brands yet",
    noLeadsDescription: "Add your first brand to start prospecting.",
    noLeadsFound: "No leads found",
    createFirst: "Add a lead",
    allSectors: "All sectors",
    allContactTypes: "All contact types",
    allDirections: "All directions",
    allStatuses: "All statuses",
    scheduledOn: "Scheduled on",
    manageLeads: "Manage your leads and track your commercial pipeline",
    pagination: {
    },
    nameRequired: "Name is required",
    statusRequired: "Status is required",
    namePlaceholder: "e.g: Company name...",
    chooseSector: "Choose a sector",
    direction: "Direction",
    chooseDirection: "Choose direction",
    newContactType: "New contact type...",
    newSector: "New sector...",
    addCategories: "Add categories",
    delete: "Delete",
    confirmDeleteCategory: "This category is used by {count} lead(s). Are you sure you want to delete it? The leads will be automatically moved to 'Other'.",
    confirmDeleteSector: "This sector is used by {count} lead(s). Are you sure you want to delete it? The sector will be removed from these leads.",
    statusInProduction: "In production",
    statusCompleted: "Completed",
    autoStatusWarning: "The {{status1}} and {{status2}} statuses also update automatically from your projects. Tip: create a project from the row’s ⋯ menu.",
    autoStatusCreateProject: "Show",
    contactValuePlaceholder: "Ex: @username, +1234567890, contact@example.com",
    noContact: "No contact",
    contactTypes: {
    },
    sendMessage: "Send message",
    rescheduleFollowUp: "Reschedule follow-up",
    moveTo: "Move to",
    markAsAbandoned: "Mark as abandoned",
    markAsRejected: "Mark as rejected",
    rescheduleTitle: "Reschedule follow-up",
    newFollowUpDate: "New follow-up date",
    quickSuggestions: "Quick suggestions",
    tomorrow: "Tomorrow",
    nextWeek: "Next week",
    nextMonth: "Next month",
    nextYear: "Next year",
  },
  projects: {
    title: "Projects",
    singular: "Project",
    createNew: "New Project",
    createNamed: "Create “{{name}}”",
    created: "{{name}} created",
    createError: "Could not create the project",
    moveTo: "Move to",
    name: "Project Name",
    nameRequired: "Name is required",
    leadRequired: "Lead is required",
    leadStillSaving: "This lead is still being saved. Try again in a second.",
    description: "Description",
    deliverables: "Expected Deliverables",
    deliverableType: "Deliverable Type",
    unknownLead: "Unknown Lead",
    typeRequired: "Type is required",
    platforms: "Platforms",
    status: "Status",
    type: "Type",
    lead: "Lead",
    namePlaceholder: "Project name...",
    descriptionPlaceholder: "Describe the project and expectations...",
    deliverablesPlaceholder: "e.g. 3 reels, 2 stories, 1 post",
    platformsPlaceholder: "e.g. Instagram, TikTok",
    manageProjectsDescription: "Track your productions and manage your deliverables",
    newProject: "New Project",
    allTypes: "All Types",
    noProjects: "No collaborations yet",
    noProjectsDescription: "Create your first collab to track deliverables.",
    createFirst: "Create a project",
    noProjectsToExport: "No projects to export. Check your filters.",
    deleted: "{{name}} deleted",
    confirmDeleteWithPaymentsTitle: "Delete this project?",
    confirmDeleteWithPayments:
      "This project has {{count}} payment tracking(s). Those payments and associated files will be permanently deleted.",
    confirmBulkDelete: "Delete {{count}} projects?",
    confirmBulkDeleteWithPayments:
      "Delete {{count}} projects? This will also permanently delete {{paymentCount}} payment tracking(s) and associated files.",
    fileUploadedSuccess: "{{name}} uploaded successfully",
    filesUploadedPartial: "{{success}} uploaded, {{error}} failed",
    documentDeleted: "{{name}} deleted",
    deleteDocumentConfirm: "Delete \"{{name}}\"? This action cannot be undone.",
    searchProject: "Search for a project...",
    searchLead: "Search for a lead...",
    generalInfo: "General Information",
    financialInfo: "Financial Information",
    assignmentRights: "Assignment Rights",
    rightsPlannedTooltip: "Planned assignment rights",
    rightsEndTooltip: "End of assignment rights",
    hasAssignmentRights: "Has assignment rights",
    noAssignmentRights: "No assignment rights",
    deadline: "Deadline",
    amount: "Amount",
    amountRequired: "Amount is required",
    amountPositive: "Amount must be positive",
    amountPlaceholder: "1500",
    currency: "Currency",
    territory: "Territory",
    territoryPlaceholder: "France, Europe, Worldwide",
    durationLabel: "Duration",
    durationPlaceholder: "12",
    durationMin: "At least 1",
    durationUnitDays: "Days",
    durationUnitWeeks: "Weeks",
    durationUnitMonths: "Months",
    durationMonthSingular: "month",
    durationMonthsPlural: "months",
    durationWeekSingular: "week",
    durationWeeksPlural: "weeks",
    durationDaySingular: "day",
    durationDaysPlural: "days",
    exclusiveRights: "Exclusive rights",
    activateImageRights: "Activate image rights",
    editImageRights: "Edit image rights",
    activateImageRightsDescription: "Confirm when usage started and adjust assignment rights if needed. The end date is calculated automatically.",
    diffusionStarted: "Activate image rights",
    diffusionStartedDescription: "Confirm when usage started and adjust assignment rights if needed. The end date is calculated automatically.",
    diffusionStartDate: "Usage start date",
    confirmDiffusionStarted: "Confirm",
    rightsUntil: "Until {{date}}",
    rightsUntilLabel: "Until",
    rightsUntilPreview: "{{duration}} → until {{date}}",
    rightsExpiredOn: "Expired on {{date}}",
    rightsExpired: "Expired",
    rightsInProgress: "In progress",
    rightsRespected: "Honored",
    rightsDurationPending: "Duration · {{duration}}",
    rightsDurationPendingHint: "Rights not activated yet. End date is set when you activate.",
    rightsEndColumn: "Rights end",
    imageRightsBadge: "image rights",
    diffusionStartedSuccess: "Image rights activated until {{date}}",
    createProject: "Create project",
    viewProject: "View project",
    manageProjects: "Manage Projects",
    noProjectsYet: "No projects for this lead",
    project: "project",
    statusBriefReceived: "Brief Received",
    statusInProduction: "In Production",
    statusFirstVersion: "V1 Sent",
    statusCorrections: "Changes Requested",
    statusDelivered: "Delivered",
    statusArchived: "Archived",
    statusBriefShort: "Brief",
    statusProductionShort: "Prod",
    statusV1Short: "V1",
    statusCorrectionsShort: "Changes",
    statusDeliveredShort: "Done",
    statusArchivedShort: "Archived",
    typeShortVideo: "Short Video",
    typePhoto: "Photo",
    typeVoiceOver: "Voice Over",
    typeStory: "Story",
    typePost: "Post / Carousel",
    typeLongVideo: "Long Video",
    typeOther: "Other",
    noBriefMessage: "No brief available for this project",
    documentUploadError: "Error while uploading document",
    documentOpenError: "Error while opening document",
    quotaExceeded: "Quota exceeded",
    documents: "Documents",
    addDocument: "Add a document",
    addDocumentTooltip: "Add a document",
    document: "Document",
    viewDocument: "View",
    openingDocument: "Opening…",
    sendDocumentToDrive: "Send to Drive",
    sendDocumentToDriveNamed: "Send to “{{name}}”",
    chooseDriveFolder: "Choose a folder…",
    chooseDriveFile: "Choose a Drive file…",
    linkDocumentFromDrive: "Link from Drive",
    openingDrivePicker: "Opening Drive…",
    openDocumentInDrive: "Open in Drive",
    resendDocumentToDrive: "Send to Drive again",
    documentSentToDrive: "{{name}} sent to Drive",
    documentLinkedFromDrive: "{{name}} linked from Drive",
    documentAlreadyLinkedFromDrive: "{{name}} is already linked",
    documentDriveNotConnected: "Connect Google Drive in Settings → Integrations",
    documentDriveExportError: "Could not send to Drive",
    documentDriveLinkError: "Could not link the Drive file",
    documentDriveLinkInaccessible:
      "Couldn’t access this file. Pick a PDF or image from My Drive.",
    documentDriveLinkSchemaError:
      "Couldn’t link this file right now. Try again in a moment.",
    documentDriveMissing: "This file is no longer available in Drive. You can send it again.",
    documentDriveLinkMissing: "This file is no longer available in Drive. The link was removed.",
    documentDriveOpenError: "Could not open the file in Drive",
    documentDrivePickerError: "Could not open the Drive picker",
    documentDrivePickerNotConfigured: "Drive picker isn’t configured yet.",
    deleteDocument: "Delete",
    deleteDocumentTitle: "Delete document",
    unlinkDocument: "Remove link",
    unlinkDocumentTitle: "Remove Drive link",
    unlinkDocumentConfirm: "Remove “{{name}}” from this project? The file stays in Drive.",
    documentUnlinked: "{{name}} unlinked",
    documentDeleteError: "Error while deleting the document",
    invalidFileType: "Only PDF files and images (JPG, PNG, WEBP, GIF) are allowed for project documents.",
    dropHere: "Drop here",
    dropFilesHere: "Drop your files here",
    noArchivedProjects: "No archived projects",
    noArchivedProjectsDescription: "Archived projects will appear here.",
    backToKanban: "Back to Kanban view",
    selectAll: "Select all",
    paid: "Paid",
    overdue: "Overdue",
    archived: "archived",
    viewPayment: "View payment",
    createPayment: "Create payment",
    addPayment: "Add payment",
    trackPayment: "Track payment",
    saveProjectFirst: "Save the project first to add documents or payments.",
    noProjectsFound: "No projects found",
  },
  payments: {
    singular: "Payment",
    noPayments: "No payments yet",
    noPaymentsDescription: "Log your first payment to track what you're owed.",
    createFirst: "Add a payment",
    noPaymentsFound: "No payments found",
    project: "Project",
    issueDate: "Issue Date",
    dueDate: "Due Date",
    dateLabel: "Due / Paid",
    dateLabelShort: "Due/Paid",
    dueOn: "Due",
    dueShort: "Due",
    paidOn: "Paid on",
    paidShort: "Paid",
    paymentDate: "Payment Date",
    status: "Status",
    amount: "Amount",
    markAsPaid: "Mark as paid",
    statusLabels: {
      sent: "Sent",
      paid: "Paid",
      overdue: "Overdue",
      pending: "Pending",
    },
    createPayment: "Create Payment",
    newPayment: "New Payment",
    editPayment: "Edit Payment",
    projectRequired: "Please select a project",
    viewProject: "View Project",
    paymentDetails: "Payment Details",
    issueDateRequired: "Issue date is required",
    dueDateRequired: "Due date is required",
    amountRequired: "Amount is required",
    amountMin: "Minimum: 0.01",
    amountBaseCurrencyRequired: "Amount in base currency is required",
    amountReceivedBaseCurrency: "Amount received ({{currency}})",
    amountReceivedBaseCurrencyHelp: "Amount actually received (may differ from invoiced amount).",
    statusLabel: "Status",
    searchByProject: "Search by project...",
    noPaymentsToExport: "No payments to export",
    invoiceNumber: "Invoice #",
    invoice: "Invoice",
    invoiceShort: "Inv.",
    addInvoice: "+ Add",
    addInvoiceShort: "+",
    addInvoiceTooltip: "Create an invoice for this payment",
    viewInvoicePdfTooltip: "Download PDF",
    selectedNoLongerAvailable: "Some selected items are no longer available. Refresh the page if needed.",
    deleted: "Payment deleted",
    confirmBulkDelete: "Delete {{count}} payments?",
  },
  invoices: {
    singular: "Invoice",
    createTitle: "New invoice",
    seller: "Seller",
    invoiceInfo: "Details",
    billedTo: "Client",
    buyerNameRequired: "Client name is required",
    lineItems: "Items",
    item: "Product or service",
    itemColumn: "Item",
    itemPlaceholder: "e.g. 3 product UGC videos",
    itemDetails: "Description",
    itemDetailsPlaceholder: "Details, deliverables…",
    qty: "Quantity",
    unitPrice: "Unit price",
    vatRate: "VAT",
    vatNotApplicable: "Not applicable",
    lineTotal: "Total",
    total: "Total",
    addLine: "Add line",
    duplicateLine: "Duplicate",
    moveLineUp: "Move up",
    moveLineDown: "Move down",
    linesRequired: "Add at least one line with a description",
    emitTitle: "New invoice",
    emitIntro: "",
    emit: "Create invoice",
    preview: "Preview",
    sectionsCompleted: "{{done}} of {{total}} sections completed",
    profileUpdateBadge: "Updates profile",
    paymentMissing: "Payment not found",
    loadError: "Could not load invoice",
    alreadyExists: "An invoice already exists for this payment",
    backToFinances: "Back to finances",
    invoiceNumber: "Invoice #",
    invoiceNumberRequired: "Invoice number is required",
    invoiceName: "Invoice name",
    invoiceNamePlaceholder: "e.g. March UGC campaign",
    issuedAt: "Date",
    issuedAtRequired: "Date is required",
    invoiceDetails: "Invoice",
    paymentSummary: "Linked payment",
    project: "Project",
    amount: "Amount",
    notes: "Notes (optional)",
    notesPlaceholder: "Legal mentions, remarks…",
    paymentTerms: "Payment terms",
    paymentDueDelay: "Due within",
    paymentDueReceipt: "On receipt",
    paymentDueDays: "{{days}} days",
    paymentDuePhraseReceipt: "Payment due on receipt",
    paymentDuePhraseDays: "Payment due within {{days}} days",
    paymentTermsNotes: "Additional details (optional)",
    paymentTermsNotesPlaceholder: "Late fees, early payment discount…",
    paymentSection: "Payment",
    paymentMethod: "Payment method",
    paymentMethodTransfer: "Bank transfer",
    paymentMethodPaypal: "PayPal",
    paymentMethodCheck: "Check",
    paymentMethodOther: "Other",
    accountHolder: "Account holder",
    accountHolderPlaceholder: "Account holder name",
    ibanLabel: "IBAN",
    ibanPlaceholder: "FR76 …",
    bicLabel: "BIC",
    bicPlaceholder: "ABCDEFGH",
    sellerFromProfileHint: "",
    create: "Create invoice",
    created: "Invoice created",
    createError: "Could not create invoice",
    numberTaken: "This invoice number is already used",
    downloadPdf: "Download PDF",
    pdfTitle: "Invoice",
    pdfFrom: "Seller",
    pdfTo: "Client",
    pdfDueDate: "Due date",
    pdfPaymentDate: "Paid on",
    pdfStatus: "Status",
    pdfAmount: "Amount",
    pdfNotes: "Notes",
    pdfSiret: "SIRET",
    pdfVatNumber: "VAT",
  },
  messages: {
    singular: "Template",
    title: "Messages",
    newTemplate: "New Template",
    manageTemplates: "Create and manage message templates for your leads",
    emailTemplates: "Message Templates",
    templatesShort: "Templates",
    composeMessage: "Compose Message",
    selectBrand: "Select a lead",
    message: "Message",
    personalizedPreview: "Personalized Preview",
    to: "To",
    noTemplatesToExport: "No templates to export",
    noTemplates: "No message templates yet",
    noTemplatesDescription: "Create a template to save time on your next outreach emails.",
    noTemplatesForFilter: "No templates of this type",
    noTemplatesForFilterDescription: "Change the filter or create a new template.",
    clearTypeFilter: "Show all templates",
    filterByType: "Filter by type",
    filterAll: "All",
    createFirst: "Create a template",
    subject: "Subject",
    templateNamePlaceholder: "Ex: First contact - Generic",
    contentPlaceholder: "Write your message here...",
    templateNameLabel: "Template name",
    templateNameRequired: "Template name is required.",
    typeLabel: "Template type",
    emailSubjectLabel: "Subject (optional)",
    emailSubjectPlaceholder: "Ex: UGC collaboration with {lead_company}",
    contentLabel: "Message content",
    openEmail: "Open in Gmail",
    copyToClipboard: "Copy",
    messageCopied: "Message copied to clipboard",
    messageCopiedAndOpened: "Message copied, channel opened",
    openContactOpened: "Channel opened",
    openContactUnavailable: "Unable to open this contact",
    openWhatsApp: "Open WhatsApp",
    openInstagram: "View Instagram profile",
    openTikTok: "View TikTok profile",
    openFacebook: "View Facebook profile",
    openTwitter: "View X profile",
    openLinkedIn: "View LinkedIn profile",
    openYouTube: "View YouTube channel",
    openWebsite: "Open website",
    openSms: "Open SMS",
    copyTemplate: "Copy",
    useTemplate: "Use template in message",
    deselectTemplate: "Deselect template",
    rewriteWithAI: "Rewrite",
    rewriteSuggest: "Suggest",
    rewriteAIPromptLabel: "Improve with AI",
    rewriteWithAIPrompt: "Other instruction…",
    rewriteWithAILoading: "Suggesting…",
    rewriteWithAIUpgradeTitle: "Upgrade to Pro to use AI rewrite",
    rewriteQuick: {
      professional: "More professional",
      shorter: "Shorter",
      warmer: "Warmer",
      fixForm: "Fix spelling & grammar",
      moreNatural: "More natural",
      translateEn: "Translate to English",
    },
    rewriteQuickInstruction: {
      professional: "Make the message more professional, without sounding salesy or spammy.",
      shorter: "Shorten the message while keeping the essentials and the same tone.",
      warmer: "Make the message warmer and more human, without being clingy.",
      fixForm:
        "Fix spelling, grammar, punctuation, and flow. Do not change the tone or meaning.",
      moreNatural:
        "Make the message more natural and less robotic. Keep the meaning and tone.",
      translateEn: "Translate the message to English, keeping the same tone and meaning.",
    },
    rewriteQuickTooltip: {
      fixForm: "Fixes form, spelling, and grammar without changing the meaning",
      professional: "More professional tone, without sounding salesy",
      warmer: "Warmer, more human tone",
      shorter: "Shortens while keeping the essentials",
      moreNatural: "Less robotic, more natural to read",
      translateEn: "Translates to English while keeping the same tone",
    },
    rewriteSuccess: "Message rewritten",
    rewriteBackTooltip: "Undo the last accepted suggestion",
    rewriteSuggestionTitle: "AI suggestion",
    rewriteBasedOn: "based on \"{{action}}\"",
    rewriteInlineHint: "Suggestions · {{action}}",
    rewriteAccept: "Accept",
    rewriteReject: "Reject",
    rewriteAcceptAll: "Accept all",
    rewriteRejectAll: "Reject all",
    rewriteBulkHint: "Or resolve all suggestions at once",
    rewriteNoChanges: "No changes suggested",
    rewriteFailed: "Rewrite failed. Please try again.",
    rewriteError_CONTENT_TOO_LONG: "Message too long for rewrite.",
    rewriteError_INSTRUCTION_TOO_LONG: "Instruction too long.",
    rewriteError_RATE_LIMIT: "Too many rewrites. Try again in a minute.",
    rewriteError_TIMEOUT: "Rewrite took too long. Please try again.",
    proFeatureModalTitle: "Pro feature",
    copy: "Copy",
    copyError: "Error copying template",
    copied: "{{name}} copied",
    deleted: "{{name}} deleted",
    searchBrand: "Search for a brand...",
    recipientPlaceholder: "Select a lead or enter contact details",
    emailSubject: "Email subject...",
    personalizedMessage: "Your personalized message...",
    variablesHelpTitle: "Variables",
    variablesInsertHint: "Click a variable to insert it into the message",
    varGroupLead: "Lead",
    varGroupMe: "You",
    varGroupProject: "Project",
    varGroupOther: "Date",
    varSelectProjectHint: "Select a project to use these variables",
    selectProjectOptional: "Project (optional)",
    noProjectSelected: "No project",
    noProjectsForLead: "No projects for this lead",
    var: {
      leadName: "Lead name",
      leadFirstName: "First name",
      leadContact: "Contact",
      leadSector: "Sector",
      myName: "Your name",
      myCompany: "Your company",
      projectName: "Project name",
      projectType: "Type",
      projectAmount: "Amount",
      projectDeadline: "Deadline",
      projectDeliverables: "Deliverables",
      rightsPlatforms: "Platforms",
      rightsDuration: "Rights duration",
      rightsTerritory: "Territory",
      rightsExclusivity: "Exclusivity",
      rightsStart: "Rights start",
      rightsEnd: "Rights end",
      today: "Today",
      tomorrow: "Tomorrow",
      in1Week: "In 1 week",
      in1Month: "In 1 month",
    },
    varTooltip: {
      leadName: "Insert the lead’s name",
      leadFirstName: "Insert the lead’s first name",
      leadContact: "Insert the lead’s contact",
      leadSector: "Insert the lead’s sector",
      myName: "Insert your name",
      myCompany: "Insert your company name",
      projectName: "Insert the project name",
      projectType: "Insert the project type",
      projectAmount: "Insert the project amount",
      projectDeadline: "Insert the project deadline",
      projectDeliverables: "Insert the project deliverables",
      rightsPlatforms: "Insert the rights platforms",
      rightsDuration: "Insert the rights duration",
      rightsTerritory: "Insert the rights territory",
      rightsExclusivity: "Insert the rights exclusivity",
      rightsStart: "Insert the rights start date",
      rightsEnd: "Insert the rights end date",
      today: "Insert today’s date",
      tomorrow: "Insert tomorrow’s date",
      in1Week: "Insert the date in one week",
      in1Month: "Insert the date in one month",
    },
    gmailSendTitle: "Gmail send",
    gmailSendModalTitle: "Send with Gmail",
    gmailSendModalSubtitle: "Double-check the recipient before sending",
    gmailSendModalLead: "Send to {{name}}",
    gmailSendFrom: "From {{email}}",
    gmailSendNowHint: "The email is sent immediately via your Gmail account",
    gmailSendConfirm: "Send",
    gmailPreview: "Preview",
    gmailAttachments: "Attachments",
    gmailIncludeSignature: "Include signature",
    gmailConnectHint: "Connect Gmail to send directly from Leadsme",
    gmailRecipient: "Recipient",
    gmailOpenInGmail: "Open in Gmail",
    gmailClearHistory: "Clear",
    gmailHistoryCleared: "Send history cleared",
    gmailClearHistoryError: "Could not clear history",
    gmailNoSentYet: "No emails sent from Leadsme for this lead yet.",
    gmailSend: "Send",
    gmailSent: "Email sent",
    gmailSendError: "Failed to send email",
    gmailError_RATE_LIMIT: "You've done too many Gmail actions at once. Try again in a minute.",
    gmailError_TOO_MANY_ATTACHMENTS: "Too many attachments (max 5).",
    gmailError_ATTACHMENTS_TOO_LARGE: "Attachments are too large (max 15 MB total).",
    gmailError_ATTACHMENT_DRIVE_LINK: "Drive-linked files can't be attached. Upload a copy to the project first.",
    gmailError_ATTACHMENT_INVALID: "Couldn't attach one of these files. Try again.",
    attach: "Attach",
    attachFile: "Attach a file",
    attachSelectedCount: "{{count}} file(s) attached",
    attachProjectFiles: "Attach a project document",
    attachFromProject: "Project files",
    noProjectFilesToAttach: "No uploaded documents on this project",
    attachLimitHint: "{{max}} files max · 15 MB total",
    detachFile: "Remove {{name}}",
    gmailInvalidEmail: "Enter a valid email address",
    gmailSubjectRequired: "Subject is required to send",
    gmailNoSubject: "No subject",
    type: {
      leadGeneration: "Lead Generation",
      followUp: "Follow-up",
      negotiation: "Negotiation",
      delivery: "Delivery",
    },
    typeShort: {
      leadGeneration: "Lead gen",
      followUp: "Follow-up",
      negotiation: "Negotiation",
      delivery: "Delivery",
    },
  },
  templates: {
    singular: "Template",
    name: "Name",
    contentType: "Content Type",
    subject: "Subject",
    content: "Content",
    createdAt: "Created at",
  },
  finances: {
    title: "Finances",
    revenue: "Revenue",
    estimatedTaxes: "Estimated taxes",
    editTaxRate: "Edit tax rate",
    currentMonth: "Current month",
    currentWeek: "Current week",
    currentYear: "Current year",
    manageFinances: "Track your revenue, payments and taxation",
    exportError: "Error exporting finances",
    netRevenue: "Net Revenue",
    grossRevenue: "Gross Revenue",
    deletedProject: "Deleted Project",
    pending: "Pending",
    overdue: "Overdue",
    revenueChart: "Revenue Chart",
    upcomingPayments: "Upcoming Payments",
    noUpcomingPayments: "No pending payments at the moment",
    allCaughtUp: "You're all caught up!",
    monthlyFinancialSummary: "Financial Summary",
    summaryShort: "Summary",
    taxDisclaimer: "Estimate only. Confirm with your accountant.",
  },
  organization: {
    title: "Organization",
    export: {
    },
    reminders: "Reminders",
    scheduleDescription: "Manage your schedule and deadlines",
    schedule: "Schedule",
    recentActivity: "Recent Activity",
    goalsDescription: "Define and track your goals",
    tasksDescription: "Organize your tasks and priorities",
    manageOrganization: "Manage your organization and data",
    totalLeads: "Total Leads",
    totalProjects: "Total Projects",
    recentActivities: "Recent Activities",
    viewCalendar: "View Calendar",
    goals: "Goals",
    setGoals: "Set Goals",
    tasks: "Tasks",
    viewTasks: "View Tasks",
  },
  calendar: {
    title: "Calendar",
    manageCalendar: "Manage your calendar and deadlines",
    month: "Month",
    week: "Week",
    day: "Day",
    previousPeriod: "Previous period",
    nextPeriod: "Next period",
    events: "Events",
    allDayShort: "All day",
    eventTitlePlaceholder: "Event title",
    startDateLabel: "Start date",
    associatedLead: "Associated Lead",
    searchLead: "Search for a lead...",
    eventDescriptionPlaceholder: "Event description...",
    editEvent: "Edit Event",
    newEvent: "New Event",
    eventTitle: "Title",
    eventTitleRequired: "Title is required.",
    eventType: "Type",
    endDateLabel: "End Date",
    eventColor: "Color",
    eventDescription: "Description",
    noEventsToExport: "No events to export",
    eventDeleted: "{{title}} deleted",
    exportError: "Error exporting calendar",
    meeting: "Meeting",
    followUp: "Follow-up",
    followUpScheduled: "Follow-up scheduled for",
    shooting: "Shooting",
    script: "Script",
    deadline: "Deadline",
    other: "Other",
    blue: "Blue",
    green: "Green",
    yellow: "Yellow",
    orange: "Orange",
    red: "Red",
    purple: "Purple",
    cyan: "Cyan",
    rose: "Pink",
    endBeforeStart: "End date can’t be earlier than start date.",
    showLeadFollowups: "Lead follow-ups",
    showPersonalEvents: "Personal events",
    showRightsEnds: "Rights end",
    rightsEndTitle: "Rights end · {{name}}",
    rightsEndDescription: "Image rights end for {{name}}",
    addToGoogleCalendar: "Add to Google Calendar",
    setupGoogleCalendar: "Connect Google Calendar to sync",
    googleCalendarSynced: "Synced to “Leadsme”",
  },
  auth: {
    minPasswordLength: "Password must be at least 8 characters",
    passwordTooLong: "Password cannot exceed 128 characters",
    passwordNotWhitespace: "Password cannot be composed only of spaces",
    passwordNoUppercase: "Password must contain at least one uppercase letter",
    passwordNoLowercase: "Password must contain at least one lowercase letter",
    passwordNoDigit: "Password must contain at least one digit",
    passwordRequirements: "Minimum 8 characters, one uppercase, one lowercase, one digit",
    forgotPassword: "Forgot password",
    forgotPasswordTitle: "Forgot password",
    emailAddress: "Email address",
    emailPlaceholder: "your@email.com",
    sending: "Sending...",
    backToLogin: "Back to login",
    loginTitle: "Sign In",
    password: "Password",
    passwordPlaceholder: "Your password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    signInError: "Sign in error",
    oauthError: "Google sign-in was interrupted. Please try again.",
    noAccount: "Don't have an account?",
    createAccount: "Create account",
    continueWithGoogle: "Continue with Google",
    orContinueWithEmail: "Or continue with email",
    signUpTitle: "Create Account",
    redirectingToApp: "Redirecting...",
    redirectingToPayment: "Redirecting to payment...",
    redirectingToResetPassword: "Preparing password reset...",
    payment: {
      cancelledMessage: "Payment not completed. No amount was charged. You can try again below.",
    },
    name: "Full name",
    namePlaceholder: "Your full name",
    company: "Company",
    companyPlaceholder: "Your company name (optional)",
    confirmPassword: "Confirm password",
    confirmPasswordPlaceholder: "Confirm your password",
    signUp: "Create account",
    signingUp: "Creating...",
    signUpError: "Error creating account",
    passwordMismatch: "Passwords do not match",
    unexpectedError: "An unexpected error occurred",
    invalidEmail: "Please enter a valid email address",
    emailAlreadyExistsMessage: "An account with this email address already exists.",
    alreadyHaveAccount: "Already have an account?",
    signInLink: "Sign in",
    termsTextPrefix: "By using this service, you accept our",
    termsLink: "Terms of Use",
    termsTextAnd: "and our",
    privacyLink: "Privacy Policy",
    resetPasswordTitle: "Reset password",
    newPassword: "New password",
    newPasswordPlaceholder: "Your new password",
    confirmNewPassword: "Confirm new password",
    confirmNewPasswordPlaceholder: "Confirm your new password",
    resetPassword: "Reset password",
    resettingPassword: "Resetting...",
    resetPasswordSuccess: "Password reset!",
    resetPasswordSuccessMessage: "Your password has been reset successfully. Redirecting...",
    resetPasswordError: "Error resetting password",
    passwordSameAsOld: "New password must be different from the old password",
    invalidResetLink: "Invalid or expired reset link",
    otpTitle: "Verify your email",
    otpTitleLogin: "Complete your signup",
    otpTitleForgot: "Reset your password",
    otpMessage: "A verification code has been sent to",
    otpMessageLogin: "To complete your signup, a verification code has been sent to",
    otpMessageForgot: "To reset your password, a verification code has been sent to",
    otpNotYourAccount: "Not your account?",
    sendResetCode: "Send code",
    otpSpamWarning: "Don't forget to check your spam folder.",
    otpCodeLabel: "Verification code (6 digits)",
    otpVerifying: "Verifying...",
    otpInvalid: "Invalid or expired code",
    otpInvalidLength: "Code must contain 6 digits",
    otpVerifyError: "Error verifying code",
    otpResend: "Resend code",
    otpResending: "Sending...",
    otpResendError: "Error sending code",
    otpResendAvailableIn: "Resend available in {{seconds}} s",
    otpResendRateLimited: "Try again in {{seconds}} s",
    otpRateLimitedGeneric: "Please wait a moment before trying again.",
    signUpRateLimited: "Try again in {{seconds}} s",
    backToSignUp: "Back to sign up",
  },
  status: {
    toContact: "To contact",
    pending: "Pending",
    negotiation: "Negotiation",
    inProduction: "In production",
    inProgress: "In Progress",
    completed: "Completed",
    abandoned: "Abandoned",
    paid: "Paid",
    rejected: "Rejected",
    unknown: "Unknown",
  },
  settings: {
    title: "Settings",
    profile: "Profile",
    preferences: "Preferences",
    integrations: "Integrations",
    integrationsSubtitle: "Centralize your tools so you can work without leaving Leadsme.",
    integrationsConnectedCount: "{{connected}} connected of {{total}}",
    integrationConnected: "Connected",
    integrationNotConnected: "Not connected",
    integrationConnect: "Connect",
    integrationDisconnect: "Disconnect",
    appColor: "App color",
    eventTypeColors: "Event types",
    googleCalendar: "Google Calendar",
    googleCalendarDescription:
      "Sync your events with your calendar.",
    googleCalendarConnect: "Connect Google Calendar",
    googleCalendarDisconnect: "Disconnect",
    googleCalendarConnected: "Connected",
    googleCalendarSyncing: "Syncing events…",
    googleCalendarConnectedToast: "Google Calendar connected",
    googleCalendarDisconnectedToast: "Google Calendar disconnected",
    googleCalendarErrorToast: "Could not connect Google Calendar",
    googleCalendarNotConfigured: "This integration isn’t available yet.",
    googleCalendarLoadError: "Couldn’t verify the connection. Try again.",
    googleCalendarConnecting: "Redirecting…",
    googleGmail: "Gmail",
    googleGmailDescription:
      "Send your emails directly from Leadsme.",
    googleGmailConnect: "Connect Gmail",
    googleGmailDisconnect: "Disconnect",
    googleGmailConnected: "Connected",
    googleGmailConnectedToast: "Gmail connected",
    googleGmailConnectedSignatureToast: "Gmail connected. You can add your signature.",
    googleGmailDisconnectedToast: "Gmail disconnected",
    googleGmailErrorToast: "Could not connect Gmail",
    googleGmailNotConfigured: "This integration isn’t available yet.",
    googleGmailLoadError: "Couldn’t verify the connection. Try again.",
    googleGmailConnecting: "Redirecting…",
    googleDrive: "Google Drive",
    googleDriveDescription:
      "Add and share files from your projects.",
    googleDriveConnect: "Connect Google Drive",
    googleDriveDisconnect: "Disconnect",
    googleDriveConnected: "Connected",
    googleDriveConnectedToast: "Google Drive connected",
    googleDriveDisconnectedToast: "Google Drive disconnected",
    googleDriveErrorToast: "Could not connect Google Drive",
    googleDriveNotConfigured: "This integration isn’t available yet.",
    googleDriveConnecting: "Redirecting…",
    superPdp: "Super PDP",
    superPdpDescription:
      "Electronic invoicing via our partner Super PDP, included in Pro with no extra fees.",
    superPdpConnect: "Connect Super PDP",
    superPdpProFeatureTitle: "Pro feature",
    superPdpProFeatureMessage:
      "Upgrade to Pro to connect Super PDP and manage sending your electronic invoices.",
    superPdpComingSoonToast: "Super PDP connection is coming soon.",
    emailSignature: "Email signature",
    emailSignatureDescription: "Added automatically when sending with Gmail.",
    emailSignaturePlaceholder: "Paste your signature or type plain text…",
    emailSignatureSaveError: "Could not save signature",
    emailSignatureTooLargeHtml: "Signature is too large (max {{max}}).",
    emailSignatureTooLargePlain: "Signature is too long (max {{max}}).",
    followUpReminder: "Follow-up reminders",
    followUpReminderDescription: "Get notified when follow-ups are due on your leads.",
    followUpReminderSaveError: "Could not save reminder preference",
    accentBlue: "Blue",
    accentIndigo: "Indigo",
    accentCyan: "Cyan",
    accentTeal: "Teal",
    accentEmerald: "Emerald",
    accentViolet: "Violet",
    accentRose: "Rose",
    accentOrange: "Orange",
    accentAmber: "Amber",
    accentSlate: "Slate",
    account: "Account",
    financial: "Financial",
    identity: "Identity",
    language: "Language",
    profileInfo: "Profile Information",
    name: "Name",
    nameRequired: "Name is required",
    company: "Company",
    taxRateRequired: "Tax rate is required",
    positiveRate: "Rate must be positive",
    maxRate: "Rate cannot exceed 100%",
    information: "Information",
    taxRateHint: "This rate is used to estimate taxes in Finances. Official rates change. See:",
    microEnterprise: "Micro-enterprise tax rules (France)",
    eurlSasu: "Corporate tax (EURL / SASU, France)",
    consultAccountant: "When in doubt, ask your accountant.",
    siretLabel: "SIRET",
    siretPlaceholder: "123 456 789 00012",
    siretInvalid: "Invalid SIRET (14 digits).",
    sirenDerived: "SIREN",
    billingIdentity: "Invoicing",
    vatNumberLabel: "VAT number (if applicable)",
    vatNumberPlaceholder: "FR12345678901",
    vatNumberInvalid: "Invalid VAT number.",
    addressLine1Label: "Address",
    addressLine1Placeholder: "12 Main Street",
    addressLine2Label: "Address line 2",
    addressLine2Placeholder: "Building, floor…",
    postalCodeLabel: "Postal code",
    postalCodePlaceholder: "75002",
    cityLabel: "City",
    cityPlaceholder: "Paris",
    countryCodeLabel: "Country",
    countryCodeInvalid: "2-letter country code (e.g. FR).",
    subtitle: "Manage your account settings and preferences",
    profileUpdateError: "Error updating profile",
    profileUpdateSuccess: "Profile updated successfully!",
    updateSuccess: "Profile updated successfully!",
    updateError: "Error updating profile",
    companyPlaceholder: "Company name",
    taxRateLabel: "Tax Rate (%)",
    subscription: "Subscription",
    currentPlan: "Current Plan",
    planFree: "Free",
    planPro: "Pro",
    planFreeDescription: "Start simply",
    planProDescription: "To grow your business",
    manageSubscription: "Manage Subscription",
    portalError: "Error opening the management portal. Please try again.",
    dataExport: "Data Export",
    dataExportDescription: "Download all your data in JSON format",
    downloadAllData: "Download All My Data",
    exportingData: "Exporting...",
    exportCooldown: "Please wait {{minutes}}m {{seconds}}s before exporting again",
    exportCooldownRemaining: "Try again in {{minutes}}m {{seconds}}s",
    dataExportSuccess: "Export successful! Download starting...",
    dataExportError: "Error exporting your data",
    deleteAccount: "Delete my account",
    deleteAccountDescription:
      "Permanently delete your account and data, and cancel any active subscription. This cannot be undone.",
    deleteAccountButton: "Delete my account",
    deleteAccountTitle: "Delete your account",
    deleteAccountWarningTitle: "This action is permanent",
    deleteAccountWarningBody:
      "Your leads, projects, files, templates and preferences will be permanently deleted. If you have a Pro subscription, it will be canceled immediately.",
    deleteAccountReasonLabel: "Why are you leaving?",
    deleteAccountCommentLabel: "A comment",
    deleteAccountOptional: "optional",
    deleteAccountReasonPlaceholder: "Choose a reason",
    deleteAccountCommentPlaceholder: "Tell us what could have been better…",
    deleteAccountConfirmPrompt: "To confirm, type {{word}}:",
    deleteAccountConfirm: "Delete permanently",
    deleteAccountDeleting: "Deleting…",
    deleteAccountError: "Could not delete your account. Please try again or contact support.",
    deleteAccountSuccess: "Your account has been deleted.",
    deleteAccountReasons: {
      too_expensive: "Too expensive",
      missing_features: "Missing features",
      too_complex: "Too complex",
      switched_tool: "I switched to another tool",
      not_using: "I'm not using Leadsme anymore",
      other: "Other",
    },
    usageLeads: "Active leads",
    usageProjects: "Active projects",
    usageEmailTemplates: "Message Templates",
    usagePayments: "Active payment trackings",
    usageEvents: "Calendar Events",
    usageStorage: "Storage",
    unlimited: "Unlimited",
    enabled: "Enabled",
    disabled: "Disabled",
    featureIncluded: "Included",
    featureNotIncluded: "Not included",
    usageError: "Unable to load usage",
    quotaLimitReached: "Limit reached",
    quotaLimitSimpleMessage:
      "{{resource}} limit reached. Delete some items to free up space, or upgrade to Pro.",
    quotaLimitProjectsMessage:
      "Active projects limit reached. Archive a project to free a slot, or upgrade to Pro.",
    quotaLimitPaymentsMessage:
      "Active payment trackings limit reached. Mark payments as paid to free a slot, or upgrade to Pro.",
    quotaLimitLeadsMessage:
      "Active leads limit reached. Abandon a cold lead to free a slot, or upgrade to Pro.",
    quotaArchiveNamed: "Archive “{{name}}”",
    quotaArchiveSuccess: "“{{name}}” archived",
    quotaArchiveFailed: "Couldn't archive the project",
    quotaMarkPaidNamed: "Mark “{{name}}” as paid",
    quotaMarkPaidSuccess: "“{{name}}” marked as paid",
    quotaMarkPaidFailed: "Couldn't mark the payment as paid",
    quotaAbandonNamed: "Abandon “{{name}}”",
    quotaAbandonSuccess: "“{{name}}” abandoned",
    quotaAbandonFailed: "Couldn't abandon the lead",
    app: "App",
  },
  import: {
    title: "Import data",
    success: "{{count}} item(s) imported successfully",
    steps: {
      upload: "File",
      mapping: "Columns",
      preview: "Import",
    },
    columnDescriptions: {
    },
    upload: {
      csvTab: "CSV/TSV File",
      pasteTab: "Paste Data",
      dragDrop: "Drag and drop, or browse your files",
      pasteInstructionsList: {
      },
      pastePlaceholder: "Paste your data here...\n\nThe first row should contain headers.\nSeparator: tab or comma.",
      fileReady: "File ready",
      or: "or",
      browse: "browse your files",
      maxSize: "Max size: 10MB",
    },
    mapping: {
      ignoreColumn: "-- Ignore this column --",
      rows: "Rows",
      columns: "Columns",
      dateFormatTitle: "Date format in your imported file",
      matchColumns: "Match your file columns",
    },
    preview: {
      warnings: "Warnings:",
      errorsFound: "Errors found",
      tableTitle: "Data preview",
      rows: "rows",
      moreRows: "more rows",
      rowsImported: "rows imported successfully",
      importError: "Error importing data",
    },
    buttons: {
      previous: "Previous",
      import: "Import",
      continue: "Continue",
      preview: "Preview",
      importing: "Importing...",
    },
    validation: {
      invalidFile: "Please select a valid CSV or TSV file.",
    },
  },
  landing: {
    home: "Home",
    seoTitle: "Leadsme - UGC Creator CRM",
    description: "Stop losing UGC leads. Manage every brand, project, payment and follow-up in one place. Built for UGC creators. Free plan. No credit card to sign up.",
    pricing: "Pricing",
    contact: "Contact",
    signIn: "Sign in",
    heroTitle: "Stop getting lost in your",
    heroTitleHighlight: "UGC collabs.",
    heroDescription: "Manage your entire activity in one place.",
    heroBadge: "Built by creators, for creators",
    ctaButton: "Get started for free",
    headerSignup: "Sign up",
    trustSignup: "Free, no credit card required",
    trustCancelAnytime: "Cancel anytime",
    heroScrollCue: "Learn more",
    heroDemoVideoLabel: "Leadsme product demo",
    featuresEyebrow: "See how it works",
    painEyebrow: "The most common problems",
    painPoint1: "You forget to follow up with some brands",
    painPoint2: "You no longer know where each collab stands",
    painPoint3: "Your briefs and information are scattered",
    painPoint4: "You lose sight of pending payments",
    painSolutionPrefix: "With Leadsme, you keep",
    painSolutionHighlight: "a clear view of your entire activity.",
    whyTitle: "Does this sound familiar?",
    whySubtitle: "Between prospecting, projects, and payments, things start to scatter.",
    featuresTitle: "Here's how Leadsme helps you never miss a lead",
    featureDashboardLabel: "Dashboard",
    featureDashboardTitle: "See your entire business at a glance",
    featureDashboardDescription: "Track your performance in real-time with key metrics and detailed charts. Identify your best leads and projects.",
    dashboardBenefit1: "Real-time view of your key metrics and performance",
    dashboardBenefit2: "Identify your best leads and most profitable projects",
    dashboardBenefit3: "Track revenue and follow-ups at a glance",
    featureLeadsLabel: "Leads",
    featureLeadsTitle: "Never lose a brand contact again",
    featureLeadsDescription: "Track your prospects, organize your contacts and manage your sales pipeline. Never miss an opportunity again.",
    leadsBenefit1: "Centralize every brand and contact",
    leadsBenefit2: "Never forget a follow-up again",
    leadsBenefit3: "Turn prospects into paid collaborations",
    featureProjectsLabel: "Projects",
    featureProjectsTitle: "Stay on top of every deliverable",
    featureProjectsDescription: "Organize your projects in Kanban, track deliverables and manage revisions. Stay in control of your productions.",
    projectsBenefit1: "Kanban view to track project progress",
    projectsBenefit2: "Never miss a deliverable deadline",
    projectsBenefit3: "Link or send docs to Google Drive",
    featureCalendarLabel: "Calendar",
    featureCalendarTitle: "Never miss a deadline",
    featureCalendarDescription: "Manage your calendar, schedule your follow-ups and visualize your deadlines. Organize your time efficiently.",
    calendarBenefit1: "Never miss a deadline",
    calendarBenefit2: "Visualize your schedule at a glance",
    calendarBenefit3: "Sync your events with Google Calendar",
    featureFinancesLabel: "Finances",
    featureFinancesTitle: "Never lose track of your payments",
    featureFinancesDescription: "Track expected and received payments in one place. Monitor your cash flow and never lose sight of who still owes you.",
    financesBenefit1: "Know exactly who still owes you money",
    financesBenefit2: "Track every payment in one place",
    financesBenefit3: "Stop chasing unpaid collaborations",
    featureMessagesLabel: "Messages",
    featureMessagesTitle: "Reply to brands and agencies in seconds",
    featureMessagesDescription: "Create and manage your personalized message templates for your leads. Automate your communication and save time.",
    messagesBenefit1: "Send your templates via Gmail in one click",
    messagesBenefit2: "Automate your outreach and follow-ups",
    messagesBenefit3: "Save hours on repetitive messages",
    heroCompatLabel: "Works with",
    integrationsEyebrow: "Google integrations",
    integrationsTitle: "Your everyday tools, right inside Leadsme",
    integrationsDescription:
      "Save time by connecting Gmail, Google Calendar, and Google Drive.",
    integrationsGmailName: "Gmail",
    integrationsGmailDescription:
      "Send emails to brands directly from Leadsme.",
    integrationsCalendarName: "Google Calendar",
    integrationsCalendarDescription:
      "Keep calls, shoots, and deadlines on your calendar.",
    integrationsDriveName: "Google Drive",
    integrationsDriveDescription:
      "Add briefs and deliverables without scattering files everywhere.",
    benefitsTitle: "Why choose Leadsme?",
    benefitSpeedTitle: "Fast and efficient",
    benefitSpeedDescription: "Save time on administrative management and focus on content creation.",
    benefitSimpleTitle: "Simple and intuitive",
    benefitSimpleDescription: "Intuitive interface designed for content creators. Get started in just a few minutes.",
    benefitGrowthTitle: "Grow your business",
    benefitGrowthDescription: "Track your performance and optimize your pipeline to generate more revenue.",
    faqTitle: "Frequently asked questions",
    faq1Question: "Can I cancel anytime?",
    faq1Answer: "Yes. Cancel anytime from your account settings.",
    faq2Question: "Is my data safe?",
    faq2Answer: "Yes. Your data is private, only accessible from your account, and never shared.",
    faq3Question: "Can I upgrade later?",
    faq3Answer: "Yes. Start for free and upgrade to Pro whenever you're ready.",
    faq4Question: "Do I need a credit card?",
    faq4Answer: "No. The free plan requires no credit card.",
    ctaTitle: "So what are you waiting for?",
    ctaDescription: "Start for free and manage your brands, projects and payments in one place.",
    copyright: "© 2025 Leadsme. All rights reserved.",
    footerLegalNav: "Legal information",
    legalMentions: "Legal",
    privacyPolicy: "Privacy",
    termsOfService: "Terms",
  },
  pricing: {
    title: "Pricing",
    description: "Start for free,\nupgrade to Pro whenever you're ready.",
    planFree: "Free",
    planFreeDescription: "Start simply",
    planPro: "Pro",
    planProDescription: "To grow your business",
    planProDescriptionYearly: "All Pro benefits, at a lower price",
    planPopular: "Popular",
    pricePerMonth: "/month",
    pricePerMonthTTC: "/month incl. tax",
    pricePerYearTTC: "/year incl. tax",
    tryFreeFor14Days: "Try free for 14 days",
    then: "then",
    bestPrice: "2 months free",
    annual: "Annual",
    monthly: "Monthly",
    ctaFree: "Create my free workspace",
    ctaNoCard: "No credit card required",
    showFeatures: "See what's included",
    proSectionTitle: "When you're ready to upgrade",
    featureUnlimitedLeads: "Unlimited leads",
    featureUnlimitedProjects: "Unlimited projects",
    featureUnlimitedTemplates: "Unlimited message templates",
    featureUnlimitedPayments: "Unlimited payment tracking",
    featureUnlimitedEvents: "Unlimited events",
    featureActiveLeads: "{{count}} active leads",
    featureActiveProjects: "{{count}} active projects",
    featureActivePayments: "{{count}} active payments",
    featureLimitedTemplates: "{{count}} message templates",
    featureLimitedEvents: "{{count}} events",
    featureEvents: "events",
    featureStorage: "{{size}} of storage",
    featureAIRewrite: "Rewrite with AI",
    checkoutError: "An error occurred during payment. Please try again later.",
  },
  contact: {
    title: "Write to the team",
    description:
      "We're building Leadsme for you. A question, a bug, an idea? Tell us what's blocking you or what's missing. We read everything.",
    name: "Name",
    namePlaceholder: "Your name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    message: "Message",
    messagePlaceholder: "Your message…",
    submitButton: "Send message",
    successTitle: "Message sent!",
    successMessage: "We'll get back to you as soon as we can.",
    rateLimited: "Too many messages sent. Please try again in a few minutes.",
    sendError: "Something went wrong. Please try again later.",
    companyHoneypot: "Company",
  },
  pwa: {
    install: "Install App",
    installed: "App installed",
    installTitle: "App Installation",
    installDescription: "Install Leadsme on your device for quick access from your home screen.",
    manualInstallTitle: "Manual installation",
    manualInstallChrome: "Click the install icon in the address bar, or use Menu > Install app",
    manualInstallSafari: "Tap Share > Add to Home Screen",
    manualInstallFirefox: "Use Menu > Install",
  },
  notFound: {
    title: "Page not found",
    description: "Sorry, we couldn't find the page you're looking for.",
    goBack: "Go back",
    goToHome: "Go to Home",
    goToDashboard: "Go to Dashboard",
  },
  blog: {
    nav: "Blog",
    seoTitle: "Leadsme Blog: Tips for UGC Creators",
    seoDescription: "Practical guides to improve your UGC outreach, manage brand collaborations and grow your creator business.",
    title: "The Leadsme Blog",
    subtitle: "Practical guides for UGC creators: outreach, collaborations, email templates and tools.",
    mediaEyebrow: "The media for UGC creators",
    heroTitle: "From outreach to collab, without improvising.",
    heroSubtitle: "Practical guides to find the right brands, defend your rates and run your creator business.",
    allGuides: "All guides",
    filterAll: "All",
    readArticle: "Read the article",
    empty: "No articles yet.",
    emptyFilter: "No guides for this topic.",
    readingTime: "{{minutes}} min read",
    backToBlog: "Back to blog",
    relatedTitle: "Read also",
    postSeoSuffix: "Leadsme Blog",
    mockToContact: "To contact",
    mockToFollowUp: "Follow up",
    mockConfirmed: "Confirmed",
    mockAddBrand: "Add a brand",
    postCtaTitle: "Don't lose track of your brand conversations",
    postCtaDescription: "Track your contacts and plan your next follow-ups with Leadsme.",
    postCtaButton: "Create my free workspace",
    postCtaOrganizeTitle: "Ready to better organize your outreach?",
    postCtaOrganizeDescription: "Centralize your brands, contacts and upcoming follow-ups in one place with Leadsme.",
    postCtaOrganizeTrust: "Free to get started",
    postCtaTrackTitle: "Ready to better track your collaborations?",
    postCtaTrackDescription: "Centralize your brands, projects, negotiated amounts and payments in one place with Leadsme.",
    postCtaTrackTrust: "Free to get started",
  },
  legal: legalTranslations,
  privacy: privacyTranslations,
  terms: termsTranslations,
} as const;
